import {normalize, schema, denormalize} from 'normalizr';

const assetCountry = new schema.Entity('assetsCountries', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {assetsCountries: [assetCountry]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = assetCountry;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = assetCountry;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default assetCountry;
